import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdrGlobeService, RegionCluster } from '../../../../core/services/cdr-globe.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-cdr-legend',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cdr-legend.component.html',
  styleUrl: './cdr-legend.component.css',
})
export class CdrLegendComponent implements OnInit {
  regions$: Observable<RegionCluster[]>;
  totalTowers$: Observable<number>;
  isLayerVisible$: Observable<boolean>;
  isExpanded: boolean = false;

  constructor(public cdrGlobeService: CdrGlobeService) {
    this.regions$ = this.cdrGlobeService.regions$;
    this.totalTowers$ = this.cdrGlobeService.totalTowers$;
    this.isLayerVisible$ = this.cdrGlobeService.isLayerVisible$;
  }

  ngOnInit(): void {}

  onCityClick(regionName: string, event: Event): void {
    event.stopPropagation();
    this.cdrGlobeService.flyToCity(regionName);
  }

  onOverviewClick(event: Event): void {
    event.stopPropagation();
    this.cdrGlobeService.flyToNigeria();
  }

  toggleLayer(event: Event): void {
    event.stopPropagation();
    this.cdrGlobeService.toggleLayer();
  }

  toggleCollapse(event: Event): void {
    event.stopPropagation();
    this.isExpanded = !this.isExpanded;
  }
}
